export default __webpack_public_path__ + "static/media/Dansn_A4_Brochure.eae7bfca.jpg";